export default __webpack_public_path__ + "static/media/ic_product_unselected.90de6757.svg";